function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
const DEBUG_EVENTS=false;
const EVENTS = {
  USER_AUTOLOGIN : 'USER_AUTOLOGIN',
  RENDER_USER_LOGGED: "RENDER_USER_LOGGED",
  RENDER_USER_NOT_LOGGED: "RENDER_USER_NOT_LOGGED",
  PAGE_BEFORE_LOADING: "PAGE_BEFORE_LOADING",
  PAGE_AFTER_RENDERING: "PAGE_AFTER_RENDERING",
  CCE_NEW_SONG:'CCE_NEW_SONG',
  CURRENT_SONG:'CURRENT_SONG',
  NEXT_SONG:'NEXT_SONG',
  PLAYER_PODCAST_NEW_SONG:'PLAYER_PODCAST_NEW_SONG',
  USER_LOGIN:'USER_LOGIN',
  USER_LOGOUT:'USER_LOGOUT',
  USER_CLICK_REGISTER_BUTTON:'USER_CLICK_REGISTER_BUTTON',
  USER_REGISTER_OK:'USER_REGISTER_OK',
  LIVE_OPEN_MENU:'LIVE_OPEN_MENU',
  LIVE_CLOSE_MENU:'LIVE_CLOSE_MENU',
  LIVE_PLAY:'LIVE_PLAY',
  LIVE_PAUSE:'LIVE_PAUSE',
  LIVE_LYRICS_DROPDOWN:'LIVE_LYRICS_DROPDOWN',
  LIVE_LYRICS_BUTTON:'LIVE_LYRICS_BUTTON',
  LIVE_CHAT_DROPDOWN:'LIVE_CHAT_DROPDOWN',
  LIVE_CHAT_SEND:'LIVE_CHAT_SEND',
  SONG_PLAY:'SONG_PLAY',
  SONG_PAUSE:'SONG_PAUSE',
  SONG_FAVORITE:'SONG_FAVORITE',
  PODCAST_SHARE:'PODCAST_SHARE',
  SHOW_LOADING:'SHOW_LOADING',
  HIDE_LOADING:'HIDE_LOADING',
  STOP_ALL_PLAYER:'STOP_ALL_PLAYER',
  PLAYER_MODE_CHANGED:'PLAYER_MODE_CHANGED',
  TRACK_PAGE:'TRACK_PAGE',
  PARTECIPA_GIOCO_SEMPLICE:'PARTECIPA_GIOCO_SEMPLICE',
  GIOCO_SEMPLICE_END:'GIOCO_SEMPLICE_END',
  REGISTRAZIONE_START:'REGISTRAZIONE_START',
  REGISTRAZIONE_CONFERMATA:'REGISTRAZIONE_CONFERMATA',
  GIOCO_CUSTOM_CODICE:'GIOCO_CUSTOM_CODICE',
  GIOCO_CUSTOM_NOCODICE:'GIOCO_CUSTOM_NOCODICE',
  GIOCO_CUSTOM_CODICE_STEP2:'GIOCO_CUSTOM_CODICE_STEP2',
}
class EventBus {
  constructor(){
    this.subscribers = {};
  }

  on(eventName, fn) {
    const id = uuidv4();
    if (!this.subscribers[eventName]) {
      this.subscribers[eventName] = [];
    }
    this.subscribers[eventName].push({ id: id, fn: fn });
    return id;
  }
  off(id) {
      for (const eventName in this.subscribers) {
          const idx = this.subscribers[eventName].findIndex((s) => s.id === id );
          if(idx != -1){
              this.subscribers[eventName].splice(idx, 1);
          }
      }
  }
  emit(eventName, data) {
    if(DEBUG_EVENTS){
      console.log(`emit event ${eventName}`, data);
    }
    if (!this.subscribers[eventName]) {
      return
    }
    for (let i = 0; i < this.subscribers[eventName].length; i++) {
      try {
        const objFn = this.subscribers[eventName][i];
        const fn = objFn.fn;
        fn.apply(this, [data]);
      } catch (error) {
        console.warn(error);
      }

    }
  }
}
const eventBus = new EventBus();
export { eventBus, EVENTS };
